import * as React from 'react'
import { FieldInputProps, FormikProps, FormikValues } from 'formik'

import TextArea from '../ui/textArea'

import './form.sass'

interface Props {
    label?: string
    error?: string
    emoji?: boolean
    placeholder?: string
    field: FieldInputProps<string>
    form: FormikProps<FormikValues>
}

const TextAreaField: React.FunctionComponent<Props> = ({
    field,
    label,
    placeholder,
    error,
    form,
    emoji = true
}: Props) => {
    return (
        <div className={error ? 'form__fieldContainer form__fieldContainer_error' : 'form__fieldContainer'}>
            <TextArea form={form} field={field} label={label} placeholder={placeholder} emoji={emoji} />
            <div className="form__fieldError">{error}</div>
        </div>
    )
}

export default TextAreaField
